import { createRoutine } from "../utils/routine.utils";
export var getMoveRequest = createRoutine("MOVE_REQUEST_GET");
export var updateMoveRequest = createRoutine("MOVE_REQUEST_UPDATE");
export var commitMoveRequest = createRoutine("MOVE_REQUEST_COMMIT");
export var requestCall = createRoutine("MOVE_REQUEST_REQUEST_CALL");
